"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionalExtraToggleButton = exports.OptionalExtraInfo = exports.OptionalExtraExplanation = exports.OptionalExtraExplanationArea = exports.OptionalExtraPrice = exports.OptionalExtraTitle = exports.OptionalExtraImage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var InfoModal_1 = require("../../../../components/modals/InfoModal");
var OptionalExtraImage = function (_a) {
    var src = _a.src, alt = _a.alt;
    return ((0, jsx_runtime_1.jsx)("img", { className: "optional-extra__img", src: src, alt: alt, height: 50 }));
};
exports.OptionalExtraImage = OptionalExtraImage;
var OptionalExtraTitle = function (_a) {
    var isOptionalExtraAdded = _a.isOptionalExtraAdded, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "optional-extra__title", children: children }));
};
exports.OptionalExtraTitle = OptionalExtraTitle;
var OptionalExtraPrice = function (_a) {
    var prefix = _a.prefix, children = _a.children, per = _a.per;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "optional-extra__price-area", children: [prefix || "for", " ", (0, jsx_runtime_1.jsx)("span", { className: "optional-extra__price", children: "".concat(children) }), " / ".concat(per)] }));
};
exports.OptionalExtraPrice = OptionalExtraPrice;
var OptionalExtraExplanationArea = function (_a) {
    var children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "optional-extra__explanation-area", children: children }));
};
exports.OptionalExtraExplanationArea = OptionalExtraExplanationArea;
var OptionalExtraExplanation = function (_a) {
    var isOptionalExtraAdded = _a.isOptionalExtraAdded, defaultExplanation = _a.defaultExplanation, explanationWhenAdded = _a.explanationWhenAdded;
    return ((0, jsx_runtime_1.jsx)("div", { className: "optional-extra__explanation", children: isOptionalExtraAdded ? explanationWhenAdded : defaultExplanation }));
};
exports.OptionalExtraExplanation = OptionalExtraExplanation;
var OptionalExtraInfo = function (props) { return ((0, jsx_runtime_1.jsx)(InfoModal_1.InfoModal, { header: props.header, className: "optional-extra__info", title: props.title, modalClassName: props.className, children: props.children })); };
exports.OptionalExtraInfo = OptionalExtraInfo;
var OptionalExtraToggleButton = function (_a) {
    var _b;
    var isActive = _a.isActive, buttonProps = __rest(_a, ["isActive"]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({}, buttonProps, { className: "custom-control custom-radio optional-extra-toggle-button ".concat(isActive ? "optional-extra-toggle-button--active" : "", " ").concat((_b = buttonProps.className) !== null && _b !== void 0 ? _b : ""), children: [(0, jsx_runtime_1.jsx)("input", { className: "custom-control-input", type: "radio", id: "".concat(buttonProps.id, "true"), value: "true", name: buttonProps.id, checked: isActive }), (0, jsx_runtime_1.jsx)("label", { className: "custom-control-label", htmlFor: "".concat(buttonProps.id, "true"), children: buttonProps.children })] })));
};
exports.OptionalExtraToggleButton = OptionalExtraToggleButton;
var OptionalExtra = /** @class */ (function (_super) {
    __extends(OptionalExtra, _super);
    function OptionalExtra() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.render = function () { return ((0, jsx_runtime_1.jsx)("div", { id: _this.props.id, className: "optional-extra ".concat(_this.props.added ? "optional-extra--added" : "", " ").concat(_this.props.isInvalid ? "is-invalid" : ""), children: _this.props.children })); };
        return _this;
    }
    return OptionalExtra;
}(React.Component));
exports.default = OptionalExtra;
//# sourceMappingURL=OptionalExtra.js.map